module.exports = __webpack_public_path__ + "img/festival_christmas.7b4049a3.png";